import { Card, Table } from 'antd';
import useStats from "hooks/useStats";
import { useEffect, useState } from 'react';
import { states } from 'utils/Tables';

const columns = [
    {
        title: 'Provincia',
        dataIndex: 'province',
        key: 'province',
        render: (text) => <a>{text}</a>,
    },
    {
        title: 'Postulantes',
        dataIndex: 'postulant',
        key: 'postulant',
    },
    {
        title: 'Instituciones',
        dataIndex: 'institution',
        key: 'institution',
    },
    {
        title: 'Total',
        dataIndex: 'total',
        key: 'total',
    },
];


const agregateDataByProvince = (data) => {
    const provinceMap = {};

    states.forEach(({ name, value }) => {
        provinceMap[value] = { province: name, postulant: 0, institution: 0, total: 0 };
    });

    data.forEach(info => {
        if (provinceMap[info?.provincia]) {
            provinceMap[info?.provincia].postulant = parseInt(info?.total_postulantes || 0);
            provinceMap[info?.provincia].institution = parseInt(info?.total_instituciones || 0);
            provinceMap[info?.provincia].total = provinceMap[info?.provincia].postulant + provinceMap[info?.provincia].institution;
        }
    });

    return Object.values(provinceMap);
};

const ProvincesTable = () => {
    const { isLoading, fetchData } = useStats('usuarios-provincia')

    const [tableData, setTableData] = useState([]);

    const fetchUsers = async () => {
        const data = await fetchData(true);

        // Generar los datos para la tabla
        const agregatedData = agregateDataByProvince(data);
        const temp = agregatedData
            .filter((province) => province.total !== 0)
            .sort((a, b) => b.total - a.total)
        setTableData(temp)
    };

    useEffect(() => {
        fetchUsers();
    }, []);

    return (
        <Card className="w-full h-full sm:overflow-auto px-6">
            <div className="text-xl font-bold text-navy-700 dark:text-white mb-5">
                Usuarios por región
            </div>
            <Table
                columns={columns}
                dataSource={tableData}
                loading={isLoading}
                rowKey={(record) => record.province}
                size='small'
                pagination={{
                    pageSize: 5
                }}
            />
        </Card>
    );
};

export default ProvincesTable;
